import { render } from "./SocioComercial.vue?vue&type=template&id=ca7a324e&scoped=true"
import script from "./SocioComercial.vue?vue&type=script&lang=js"
export * from "./SocioComercial.vue?vue&type=script&lang=js"

import "./SocioComercial.vue?vue&type=style&index=0&id=ca7a324e&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7a324e"]])

export default __exports__